import { RichTextInput } from 'ra-input-rich-text';

import { CustomRichTextToolbar } from './CustomRichTextToolbar';
import './styles.css';

export const CustomRichText = ({ ...props }) => {
  return (
    <div style={{ width: '100%', border: '1px solid rgba(0,0,0,0.1)', padding: '15px' }}>
      <RichTextInput
        {...props}
        style={{ border: '1px solid rgba(0,0,0,0.1)' }}
        source={props.source}
        toolbar={<CustomRichTextToolbar size="large" />}
        fullWidth
      />
    </div>
  );
};
